import http from '../http'
import {DOCUMENT_URL} from '@/services/endpoints'


export function getDocumentList(objectId) {
  return http.request({
    url: DOCUMENT_URL + `/${objectId}`,
    method: 'get'
  })
}

export function updateDocumentList(objectId, documentTypeId, data) {
  return http.request({
    url: DOCUMENT_URL + `/${documentTypeId}/${objectId}`,
    method: 'put',
    data: data
  })
}

export function deleteDocument({object_id, document_type_id, id}) {
  return http.request({
    url: DOCUMENT_URL + `/${document_type_id}/${object_id}/${id}`,
    method: 'delete'
  })
}

export function deleteDocumentList(objectId, documentTypeId, listOfIds) {
  return http.request({
    url: DOCUMENT_URL + `/${documentTypeId}/${objectId}`,
    method: 'delete',
    data: {list: listOfIds}
  })
}

export function downloadDocument(objectId, documentTypeId, documentId, name, extension) {
  return http.request({
    url: DOCUMENT_URL + `/${documentTypeId}/${objectId}/${documentId}/download`,
    method: 'get',
    responseType: 'blob'
  }).then((response) => {
    const url = window.URL.createObjectURL(new Blob([response]));
    const link = document.createElement('a');
    link.href = url;
    const fileExtension = response.type.substr((response.type.lastIndexOf('/') + 1));
    link.setAttribute('download', name +'.' + fileExtension); //or any other extension
    document.body.appendChild(link);
    link.click();
  })
}


export function downloadListOfDocuments(objectId, documentTypeId, list, filename = 'documents') {
  return http.request({
    url: DOCUMENT_URL + `/${documentTypeId}/${objectId}/download`,
    method: 'post',
    data: {list: list},
    responseType: 'blob'
  }).then((response) => {
    const url = window.URL.createObjectURL(new Blob([response]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${filename}.zip`); //or any other extension
    document.body.appendChild(link);
    link.click();
  })
}
export function updateDocumentName(id, data) {
  return http.request({
    url: DOCUMENT_URL + `/${id}`,
    method: 'put',
    data: data
  })
}
export function documentTypeList(params) {
  return http.request({
    url: DOCUMENT_URL + `/type-list`,
    method: 'get',
    params
  })
}
export function uploadDocument(documentType, objectId, data) {
  return http.request({
    url:  DOCUMENT_URL + `/${documentType}/${objectId}`,
    method: 'post',
    data: data
  })
}

